export const ListConfig = {
    name            : 'Task list',
    menuName        : 'List',
    icon            : 'i5-tasks',
    image           : 'list',
    iconSvg         : 'isvg-view-list',
    url             : 'list',
    stringId        : 'tasks_list',
    description     : 'List of project/folder tasks grouped by status, user, or other attributes.',
    inheritance     : true,
    hasTemplates    : true,
    canBeInProject  : true,
}

export const PROJECT_LIST_CONFIG = {
    ...ListConfig,
    // key2: "newValue2",  // Replacing the value for key2
}